export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5678.30c29bd6.jpg";